





















































































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ajax from '@/lib/ajax';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({ name: 'OpportunityContactDetailsEdit' })
export default class extends GiganautVueDialog {
  selectedContact: any = null;
  scopedContacts: any[] = [];
  loadingScopedContacts = false;
  showAllCompanyContacts = false;

  entity = {
    prospectContactFirstName: '',
    prospectContactLastName: '',
    prospectContactEmail: '',
    prospectContactMobilePhoneNumber: '',
    prospectContactOtherPhoneNumber: '',
    prospectContactJobTitle: '',
    prospectContactPositionId: null as string | null,
    prospectContactIsAgreedToMarketing: false,
  };

  get opportunity() { return OpportunityDetailsModule.opportunity; }
  get saving() { return OpportunityDetailsModule.saving; }
  get positions() { return AgencySettingsModule.positions; }

  get contactScopeLabel(): string {
    if (!this.opportunity) return '';
    if (this.opportunity.locationId && !this.showAllCompanyContacts) {
      return this.opportunity.location?.brandName
        ? `at ${this.opportunity.location.brandName}`
        : 'at this location';
    }
    if (this.opportunity.companyId) {
      return this.opportunity.company?.brandName
        ? `at ${this.opportunity.company.brandName}`
        : 'at this company';
    }
    return '';
  }

  get contactPickerPlaceholder(): string {
    if (!this.opportunity?.companyId && !this.opportunity?.locationId) {
      return 'Link a company or location first';
    }
    return 'Search for a contact...';
  }

  contactLabel(item: any) {
    return item && item.person ? `${item.person.firstName} ${item.person.lastName}` : '';
  }

  async refreshScopedContacts() {
    if (!this.opportunity) return;
    const useLocation = this.opportunity.locationId && !this.showAllCompanyContacts;
    const url = useLocation
      ? `/api/v1/agency/locations/${this.opportunity.locationId}/contacts`
      : (this.opportunity.companyId ? `/api/v1/agency/companies/${this.opportunity.companyId}/contacts` : null);
    if (!url) {
      this.scopedContacts = [];
      return;
    }
    this.loadingScopedContacts = true;
    try {
      const r = await ajax.get(url);
      const rows = r.data || [];
      this.scopedContacts = useLocation
        ? rows.map((cl: any) => cl.contact).filter(Boolean)
        : rows;
    } finally {
      this.loadingScopedContacts = false;
    }
  }

  @Watch('showAllCompanyContacts')
  onScopeToggled() { this.refreshScopedContacts(); }

  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (!val || !this.opportunity) return;
    const o = this.opportunity;
    this.selectedContact = o.contact || null;
    this.showAllCompanyContacts = !o.locationId;
    this.entity.prospectContactFirstName = o.prospectContactFirstName;
    this.entity.prospectContactLastName = o.prospectContactLastName;
    this.entity.prospectContactEmail = o.prospectContactEmail;
    this.entity.prospectContactMobilePhoneNumber = o.prospectContactMobilePhoneNumber;
    this.entity.prospectContactOtherPhoneNumber = o.prospectContactOtherPhoneNumber;
    this.entity.prospectContactJobTitle = o.prospectContactJobTitle;
    this.entity.prospectContactPositionId = o.prospectContactPositionId;
    this.entity.prospectContactIsAgreedToMarketing = o.prospectContactIsAgreedToMarketing;
    if (AgencySettingsModule.positions.length === 0) AgencySettingsModule.getPositions();
    this.refreshScopedContacts();
  }

  // Linking a real contact promotes the opportunity out of "opportunity
  // contact" status, which drops it from any draft campaign audiences. Warn
  // the user first so the removal isn't a surprise.
  async confirmContactLinkRemovesFromCampaigns(opportunityId: string): Promise<boolean> {
    let drafts: any[] = [];
    try {
      const r = await ajax.get(`/api/v1/agency/opportunities/${opportunityId}/draft-campaigns`);
      drafts = r.data || [];
    } catch {
      // If the check fails, don't block the link — just proceed.
      return true;
    }
    if (drafts.length === 0) return true;
    const names = drafts.map((d: any) => d.name).join(', ');
    const options: VuetifyConfirmObject = {
      buttonTrueText: 'CONTINUE',
      buttonFalseText: 'CANCEL',
      buttonTrueColor: 'primary',
      buttonFalseColor: 'grey',
    };
    return this.$confirm(
      `This prospect is in ${drafts.length} draft campaign audience(s) (${names}). `
      + 'Linking a contact will remove them from those audiences — re-add them from the Contacts tab if you still want to email them. Continue?',
      options,
    );
  }

  async save() {
    if (!(this.$refs.form as any).validate() || !this.opportunity) return;
    const opp = this.opportunity;
    const newContactId = this.selectedContact ? this.selectedContact.id : null;

    // Promoting an opportunity contact to a real contact (was null, now set).
    if (newContactId && !opp.contactId) {
      const proceed = await this.confirmContactLinkRemovesFromCampaigns(opp.id);
      if (!proceed) return;
    }

    if (newContactId !== (opp.contactId || null)) {
      await OpportunityDetailsModule.updateLinks({
        id: opp.id,
        companyId: opp.companyId,
        locationId: opp.locationId,
        contactId: newContactId,
        updatedAt: opp.updatedAt,
      });
    }
    if (!newContactId) {
      const refreshed = OpportunityDetailsModule.opportunity!;
      await OpportunityDetailsModule.updateProspectContact({
        id: opp.id,
        updatedAt: refreshed.updatedAt,
        ...this.entity,
      });
    }
    this.dialog = false;
  }
}
